import React, { useState, useEffect, useContext,useMemo } from 'react';
import { 
  Table, 
  Button, 
  Form, 
  InputGroup, 
  Dropdown, 
  DropdownButton 
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, useParams } from "react-router-dom";
import { 
  faFilter, 
  faChartLine, 
  faMoneyBillWave 
} from '@fortawesome/free-solid-svg-icons';
import axios from "axios";
import Select from 'react-select';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MyContext from "../../../MyContext";
import "../AdminDashboard.css"
import NoIndex from "../../NoIndex";

const ClientBillingTable = ({Admin}) => {
    const { baseUrl, config } = useContext(MyContext);
    const navigate = useNavigate();
    const viewBilling = (clientId,clientName) => {
      toast.info('Generating Billing Insights', {
        position: "top-right",
        autoClose: 1000
      });
      navigate(`/admin/billing/bill/${clientId}/${clientName}`);
    };
    const viewInsights = (clientId,clientName) => {
      toast.info('Generating Billing Insights', {
        position: "top-right",
        autoClose: 1000
      });
      navigate(`/admin/billing/insights/${clientId}/${clientName}`);
    };
  const [clientData, setClientData] = useState([
  
  ]);
  const FetchClientCall = async () => {
    // setLoading(true);
    try {
      const UserDetail = {
        userid: Admin.pkid,
     
      };

      const response = await axios.post(
        `${baseUrl}/api/Admin/v1.0/getUserBillingData`,
        UserDetail,
        config
      );

      if (response.data.responseCode === "00") {
        // toast.success(response.data.responseMessage);
        setClientData(response.data.response);
  
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error fetching clients");
    } finally {
    //   setLoading(false);
    }
  };
  useEffect(() => {
    FetchClientCall();
  }, [])
  
  // Filtering states
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState(null);
  const [dateFilter, setDateFilter] = useState(null);

  // Status filter options
  const statusOptions = [
    { value: 'Paid', label: 'Paid' },
    { value: 'Pending', label: 'Pending' },
    { value: 'Overdue', label: 'Overdue' }
  ];

  // Filtered and memoized data
  const filteredData = useMemo(() => {
    return clientData.filter(client => {
      const matchesSearch = client.user_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                             client.project?.toLowerCase().includes(searchTerm.toLowerCase());
      
      const matchesStatus = !statusFilter || client.status === statusFilter.value;
      
      return matchesSearch && matchesStatus;
    });
  }, [clientData, searchTerm, statusFilter]);

  // Action Handlers
  const handleInsights = () => {
    toast.info('Generating Billing Insights', {
      position: "top-right",
      autoClose: 3000
    });
    // Implement actual insights logic
  };

  const handleBilling = () => {
    toast.success('Opening Billing Management', {
      position: "top-right",
      autoClose: 3000
    });
    // Implement actual billing management logic
  };

  return (
    <div className=" p-4 marginRight">
      <div className="p-2 mb-2 rounded-2 admin-green-gradient admin-popup">     <h2 className="text-start mb-4 ms-2">Billing</h2>
           <hr className="mb-4" />  <NoIndex />
      <ToastContainer />
      <div className="row mb-3 align-items-center">
        <div className="col-md-4">
          <InputGroup>
            <Form.Control
              placeholder="Search clients or projects"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <InputGroup.Text><FontAwesomeIcon icon={faFilter} /></InputGroup.Text>
          </InputGroup>
        </div>
        <div className="col-md-3">
          <Select
            options={statusOptions}
            placeholder="Filter by Status"
            isClearable
            onChange={setStatusFilter}
          />
        </div>
    
      </div></div>
      

      <div className="scrollable-table">
        <table className="table table-bordered table-hover">
          <thead style={{ borderRadius: "10px" }}>
            <tr     className="text-center greenColour py-4"
                                            style={{
                                                borderBottom: "1px solid #ccc",
                                            }}>
              <th className="p-3 th-style">Client Name</th>
            
              <th className="p-3 th-style">Total Billing</th>
              <th className="p-3 th-style">Status</th>
              <th className="p-3 th-style">Date</th>
              <th className="p-3 th-style">Action</th>

            </tr>
          </thead>
          <tbody>
            {filteredData.map(client => (
              <tr key={client.id}>
                <td className="text-center">{client.user_name}</td>
              
                <td className="text-center"> ₹ {client.billingAmount}</td>
                <td  className="text-center">
                  <span 
                    className={`badge ${
                      client.billingStatus === 'Paid' ? 'bg-success' : 
                      client.billingStatus === 'Pending' ? 'bg-warning' : 
                      'bg-danger'
                    }`}
                  >
                    {client.billingStatus}
                  </span>
                </td>
                <td className="text-center">{client.updatedOn}</td>
                <td  className="text-center"> 
                     <div className="col-md-5 d-flex justify-content-center">
          <Button 
            variant="primary" 
            className="me-2 h-50"
            title='Insights'
            onClick={()=>viewInsights(client.id,client.user_name)}
          >
            <FontAwesomeIcon icon={faChartLine} />
  
          </Button>
          <Button 
            variant="success"
             className="me-2 h-50"
                title='Billing'
            onClick={()=>viewBilling(client.id,client.user_name)}
          >
            <FontAwesomeIcon icon={faMoneyBillWave} />
     
          </Button>
        </div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ClientBillingTable;